import { logoutCCP } from '../../../contexts/CallCenterContext/services/CallCenterServicesContext';
import { useAuthLogout } from '../../../uc-api-sdk';

export const useLogout = () => {
  const logoutInfo = useAuthLogout({ options: { sendOnMount: false, retry: 0 } });

  const onLogout = async (notifyServer?: boolean) => {
    try {
      if (notifyServer) {
        await logoutInfo.send({ params: {} });
      }
    } catch (error) {
      console.error(error);
    } finally {
      // logout AWS connect
      logoutCCP();
      // clean sessionStorage
      sessionStorage.clear();
      window.dispatchEvent(new Event('session-storage'));
    }
  };

  return {
    onLogout,
    isLoggingOut: !!logoutInfo.isLoading,
  };
};
